var carto = function () {
    var filtersClose = function () {
        var state = false;
        var btn = $('.carto .filters-close');
        var filters = $('.filters');
        btn.click(function () {
            if (state === true) {
                //close
                filters.removeClass('filters--active');
                state = false;
            } else {
                // open
                filters.addClass('filters--active');
                state = true;
            }
        });
    };

    filtersClose();
};

